const I18N_DOMAIN_FACETED_SEARCH = 'tui-faceted-search';

const FACETED_MODE = {
	ADVANCED: 'advanced',
	BASIC: 'basic',
};

const USAGE_TRACKING_TAGS = {
	ADVANCED: 'filter.advanced',
	ADVANCED_APPLY: 'filter.advanced.apply',
	ADVANCED_CLEAR: 'filter.advanced.clear',
	BASIC: 'filter.basic',
	BASIC_ADD: 'filter.basic.add',
	BASIC_CLEAR: 'filter.basic.clear',
	COLLAPSE: 'filter.collapse',
	EXPAND: 'filter.expand',
	BADGE_REMOVE: 'filter.remove',
	BADGE_ADD: 'filter.#{badgeName}.add',
};

export { I18N_DOMAIN_FACETED_SEARCH, FACETED_MODE, USAGE_TRACKING_TAGS };
